module.exports = __webpack_public_path__ + "static/media/home.bf280efd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home.jpg
// module id = 79
// module chunks = 0